import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Hook to preserve independent navigation stacks for each bottom tab.
 * Re-selecting an active tab resets its stack to the root view.
 */
export function useNavigationStack(tabName, rootPath) {
  const navigate = useNavigate();
  const location = useLocation();
  const stackRef = useRef([]);

  useEffect(() => {
    // Initialize stack for this tab
    if (location.pathname === rootPath) {
      stackRef.current = [rootPath];
    }
  }, [location.pathname, rootPath]);

  const handleTabSelect = (isActive) => {
    if (isActive) {
      // Reset to root if already on this tab
      navigate(rootPath);
      stackRef.current = [rootPath];
    } else {
      // Navigate to this tab's root
      stackRef.current = [rootPath];
      navigate(rootPath);
    }
  };

  const pushPage = (path) => {
    if (!stackRef.current.includes(path)) {
      stackRef.current.push(path);
    }
    navigate(path);
  };

  const popPage = () => {
    if (stackRef.current.length > 1) {
      stackRef.current.pop();
      navigate(stackRef.current[stackRef.current.length - 1]);
    }
  };

  return { handleTabSelect, pushPage, popPage, currentStack: stackRef.current };
}